import { Component, Input } from '@angular/core';

@Component({
  selector: 'mydocma-co-calibration-icon',
  templateUrl: './calibration-icon.component.html',
  styleUrls: ['./calibration-icon.component.scss']
})
export class CalibrationIconComponent {

  @Input() iconName = '_crosshair_hover';
  @Input() pinNumber: string = null;

  attachToPin(pin: { id?: string }): void {
    this.pinNumber = this.toPinNumber(pin?.id);
  }

  private toPinNumber(pinId: string): string {
    return pinId === '1' || pinId === '2' ? pinId : null;
  }
}
